<template>
      <!-- Planilla Detalles Dialog -->
      <v-dialog v-model="dialog" fullscreen persistent>
        <v-card ref="form">
          <v-app-bar color="white" elevate-on-scroll flat>
            <span>{{ "DETALLES DE PLANILLA: " + (planillaActual ? planillaActual.codigo : '') }}</span>
            <v-spacer></v-spacer>
            <v-tooltip bottom v-if="selectDetalles.length > 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon large @click="desactivarMasivo" color="error" v-bind="attrs" v-on="on">
                  <v-icon dark> delete </v-icon>
                </v-btn>
              </template>
              <span>Eliminar Seleccionados</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon large @click="importarPersonas" color="primary" v-bind="attrs" v-on="on">
                  <v-icon dark> fa-solid fa-arrows-down-to-people </v-icon>
                </v-btn>
              </template>
              <span>Importar Personas</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="close()" color="primary" v-bind="attrs" v-on="on" fab>
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Volver</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-card class="overflow-hidden">
              <v-sheet class="overflow-y-auto" :max-height="height + 110">
                 <v-system-bar color="white">
                          <v-icon>{{
                            contarPersonasSeleccionadas === 0
                              ? "fa-regular fa-circle"
                              : contarPersonasSeleccionadas === 1
                              ? "fa-solid fa-user"
                              : "fa-solid fa-users"
                          }}</v-icon>
                          <span
                            >{{
                              contarPersonasSeleccionadas === 0
                                ? "0/" + planillaDetallesList.length + " personas seleccionadas."
                                : contarPersonasSeleccionadas === 1
                                ? "1/" + planillaDetallesList.length + " persona seleccionada."
                                : contarPersonasSeleccionadas + "/" + planillaDetallesList.length + " personas seleccionadas"
                            }}
                          </span>
                        </v-system-bar>
                        <v-toolbar flat color="white" dense>
                          <v-row class="mt-2">
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                v-model="searchDetalleValue"
                                append-icon="search"
                                label="Buscar por código o nombre"
                                single-line
                                hide-details
                                dense
                                outlined
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-autocomplete
                                v-model="searchAreaDetalleValue"
                                :items="cargosEnPlanilla"
                                item-text="descripcion"
                                item-value="id"
                                label="Filtrar por Cargo"
                                clearable
                                hide-details
                                dense
                                outlined
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-toolbar>
                <v-data-table
                  dense
                  fixed-header
                  :height="height-85"
                  :items="planillaDetallesList"
                  :loading="loadTableDetalles"
                  v-model="selectDetalles"
                  :headers="headersDetalle"
                  :hide-default-header="false"
                  :hide-default-footer="true"
                  :search="searchDetalleValue"
                  item-key="id"
                  show-select
                  
                  class="elevation-1"
                  checkbox-color="primary"
                  :header-props="{
                    'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                  }"
                  :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [-1, 100, 150, 200],
            }"
                >

              

              <!-- EDIT SUELDO HIPOTETICO -->
              <template v-slot:[`item.sueldo`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.sueldo"
                  large
                  @save="guardarDetalleEnLinea(item)"
                  save-text="Asignar"
                  cancel-text="Cancelar"
                >
                  <div :class="{'primary--text font-weight-bold': item.sueldo != null && item.sueldo !== ''}">
                    {{ item.sueldo != null && item.sueldo !== '' ? formatoNumero(item.sueldo, 2) : (item.persona_sueldo != null ? formatoNumero(item.persona_sueldo, 2) : '-') }}
                  </div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.sueldo"
                      type="number"
                      label="Sueldo Hipotético"
                      single-line
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>

              <!-- EDIT COMISION HIPOTETICA -->
              <template v-slot:[`item.comision`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.comision"
                  large
                  @save="guardarDetalleEnLinea(item)"
                  save-text="Asignar"
                  cancel-text="Cancelar"
                >
                  <div :class="{'primary--text font-weight-bold': item.comision != null && item.comision !== ''}">
                    {{ item.comision != null && item.comision !== '' ? formatoNumero(item.comision, 2) : (item.persona_comision != null ? formatoNumero(item.persona_comision, 2) : '-') }}
                  </div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.comision"
                      type="number"
                      label="Comisión Hipotética"
                      single-line
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>
              
            

              <!-- EDIT GRUPO NOMINA -->
              <template v-slot:[`item.id_grupo_nomina`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.id_grupo_nomina"
                  large
                  @save="guardarDetalleEnLinea(item)"
                  save-text="Asignar"
                  cancel-text="Cancelar"
                >
                  <div :class="{'primary--text font-weight-bold': item.id_grupo_nomina}">
                    {{ obtenerNombreGrupo(item.id_grupo_nomina || item.persona_id_grupo_nomina) || '-' }}
                  </div>
                  <template v-slot:input>
                    <v-autocomplete
                      v-model="item.id_grupo_nomina"
                      :items="grupos"
                      item-text="descripcion"
                      item-value="id"
                      label="Grupo Nómina"
                    ></v-autocomplete>
                  </template>
                </v-edit-dialog>
              </template>
              
              <!-- EDIT CARGO -->
              <template v-slot:[`item.id_cargo`]="{ item }">
                <div :class="{'primary--text font-weight-bold': item.id_cargo}">
                  {{ obtenerNombreCargo(item.id_cargo || item.persona_id_cargo) || '-' }}
                </div>
              </template>

              <!-- EDIT SUBSIDIO -->
              <template v-slot:[`item.subsidio_info`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.cant_subsidio"
                  large
                  @save="guardarDetalleEnLinea(item)"
                  save-text="Asignar"
                  cancel-text="Cancelar"
                >
                  <div :class="{'primary--text font-weight-bold': item.cant_subsidio != null}">
                    <v-badge
                      color="red"
                      :value="(item.cant_subsidio != null ? item.cant_subsidio : item.persona_cant_subsidio) > 0 ? '' : 'd-none'"
                    >
                      {{ (item.cant_subsidio != null ? item.cant_subsidio : item.persona_cant_subsidio) > 0 ? "SI" : "NO" }}
                    </v-badge>
                    <v-list-item-subtitle v-if="(item.cant_subsidio != null ? item.cant_subsidio : item.persona_cant_subsidio) > 0">
                      {{ formatoFechaSpanish(item.fecha_subsidio_1 || item.persona_fecha_subsidio_1) }}
                    </v-list-item-subtitle>
                  </div>
                  <template v-slot:input>
                    <v-autocomplete
                      outlined dense
                      v-model="item.cant_subsidio"
                      :items="[0, 1, 2, 3]"
                      label="Cantidad de subsidios"
                    ></v-autocomplete>
                    <v-text-field
                      v-if="item.cant_subsidio > 0"
                      outlined dense type="date"
                      v-model="item.fecha_subsidio_1"
                      label="Fecha inicio Subsidio 1"
                    ></v-text-field>
                    <v-text-field
                      v-if="item.cant_subsidio > 1"
                      outlined dense type="date"
                      v-model="item.fecha_subsidio_2"
                      label="Fecha inicio Subsidio 2"
                    ></v-text-field>
                    <v-text-field
                      v-if="item.cant_subsidio > 2"
                      outlined dense type="date"
                      v-model="item.fecha_subsidio_3"
                      label="Fecha inicio Subsidio 3"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>

              <!-- FECHAS -->
              <template v-slot:[`item.fecha_ingreso`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.fecha_ingreso"
                  large
                  @save="guardarDetalleEnLinea(item)"
                  save-text="Asignar"
                  cancel-text="Cancelar"
                >
                  <div :class="{'primary--text font-weight-bold': item.fecha_ingreso}">
                    {{ formatoFechaSpanish(item.fecha_ingreso || item.persona_fecha_ingreso) }}
                  </div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.fecha_ingreso"
                      type="date"
                      label="Ingreso Hipotético"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>

              <template v-slot:[`item.fecha_salida`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.fecha_salida"
                  large
                  @save="guardarDetalleEnLinea(item)"
                  save-text="Asignar"
                  cancel-text="Cancelar"
                >
                  <div :class="{'primary--text font-weight-bold': item.fecha_salida}">
                    {{ formatoFechaSpanish(item.fecha_salida || item.persona_fecha_salida) }}
                  </div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.fecha_salida"
                      type="date"
                      label="Salida Hipotética"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>

              <template v-slot:no-data>
                No hay personas en esta planilla. (Array length: {{ planillaDetallesList.length }})
              </template>
            </v-data-table>
              </v-sheet>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
</template>


<script>
import axios from "axios";

export default {
  name: 'DialogDetallesPlanilla',
  data() {
    return {
      dialog: false,
      width: 0,
      height: 0,
      usuario: this.$store.state.usuario.user,
      planillaActual: null,
      planillaDetallesList: [],
      cargos: [],
      grupos: [],
      pageDetalle: 1,
      loadTableDetalles: false,
      selectDetalles: [],
      searchDetalleValue: "",
      searchAreaDetalleValue: "",
      headersDetalle: [
        { text: "Código", value: "persona_codigo", class: "primary white--text text-subtitle-2" },
        { text: "Nombre", value: "persona_nombre", class: "primary white--text text-subtitle-2" },
        { text: "Cargo", value: "id_cargo", filter: this.filtroAreaDetalle, class: "primary white--text text-subtitle-2" },
        { text: "Grupo", value: "id_grupo_nomina", class: "primary white--text text-subtitle-2" },
        { text: "Sueldo", value: "sueldo", class: "primary white--text text-subtitle-2" },
        { text: "Comisión", value: "comision", class: "primary white--text text-subtitle-2" },
        { text: "Subsidio", value: "subsidio_info", sortable: false, class: "primary white--text text-subtitle-2" },
        { text: "Ingreso", value: "fecha_ingreso", class: "primary white--text text-subtitle-2" },
        { text: "Salida", value: "fecha_salida", class: "primary white--text text-subtitle-2" },
      ],
    };
  },
  computed: {
    cargosEnPlanilla() {
      const detalles = Array.isArray(this.planillaDetallesList) ? this.planillaDetallesList : [];
      const idsCargosPresentes = new Set(
        detalles.map(item => item.id_cargo || item.persona_id_cargo)
      );
      return this.cargos.filter(cargo => idsCargosPresentes.has(cargo.id));
    },
    contarPersonasSeleccionadas() {
      return this.selectDetalles.length;
    }
  },
  created() {
    this.listarCargos();
    this.listarGrupos();
  },
  mounted() {
    this.getDimensions();
    window.addEventListener("resize", this.getDimensions);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getDimensions);
  },
  methods: {
    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    open(planillaId) {
      this.dialog = true;
      this.listarDetalles(planillaId);
    },
    close() {
      this.dialog = false;
    },
    listarDetalles(idPlanilla) {
      let me = this;
      me.loadTableDetalles = true;
      me.planillaDetallesList = [];
      me.selectDetalles = [];
      axios.get("api/planilla_detalles/listar/" + idPlanilla)
        .then(function (response) {
          me.planillaDetallesList = Array.isArray(response.data) ? response.data : [];
          me.loadTableDetalles = false;
        })
        .catch(function (error) {
          me.loadTableDetalles = false;
          console.log(error);
        });
        
      // Fetch Planilla data to show Code
      axios.get("api/planillas/mostrar/" + idPlanilla)
        .then(function (response) {
          me.planillaActual = response.data;
        });
    },
    listarCargos() {
      let me = this;
      axios.get("api/cargos/listar").then(response => { me.cargos = Array.isArray(response.data) ? response.data : []; });
    },
    listarGrupos() {
      let me = this;
      axios.get("api/grupo_nominas/listar").then(response => { me.grupos = Array.isArray(response.data) ? response.data : []; });
    },
    filtroAreaDetalle(value, search, item) {
      if (!this.searchAreaDetalleValue) return true;
      const cargoId = item.id_cargo || item.persona_id_cargo;
      return cargoId === this.searchAreaDetalleValue;
    },
    guardarDetalleEnLinea(item) {
      let me = this;
      let payload = { ...item };
      payload.usuario = me.usuario;
      if (payload.fecha_ingreso && payload.fecha_ingreso.length > 10) payload.fecha_ingreso = payload.fecha_ingreso.substring(0,10);
      if (payload.fecha_salida && payload.fecha_salida.length > 10) payload.fecha_salida = payload.fecha_salida.substring(0,10);
      if (payload.fecha_subsidio_1 && payload.fecha_subsidio_1.length > 10) payload.fecha_subsidio_1 = payload.fecha_subsidio_1.substring(0,10);
      if (payload.fecha_subsidio_2 && payload.fecha_subsidio_2.length > 10) payload.fecha_subsidio_2 = payload.fecha_subsidio_2.substring(0,10);
      if (payload.fecha_subsidio_3 && payload.fecha_subsidio_3.length > 10) payload.fecha_subsidio_3 = payload.fecha_subsidio_3.substring(0,10);
      
      axios.put("api/planilla_detalles/actualizar", payload)
        .then(function (response) {
          me.listarDetalles(me.planillaActual.id);
          me.$store.dispatch("setSnackbar", { text: "Registro actualizado.", color: "success" });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: (error.response && error.response.data) || "Error", color: "error" });
        });
    },
    desactivarMasivo() {
      if(this.selectDetalles.length === 0) return;
      if(!confirm("¿Está seguro de eliminar estas personas de la planilla?")) return;
      let me = this;
      let promises = [];
      me.selectDetalles.forEach(item => {
        promises.push(axios.put("api/planilla_detalles/desactivar/" + item.id, { usuario: me.usuario }));
      });
      Promise.all(promises).then(() => {
        me.listarDetalles(me.planillaActual.id);
        me.selectDetalles = [];
        me.$store.dispatch("setSnackbar", { text: "Registros eliminados.", color: "success" });
      }).catch(err => {
        me.$store.dispatch("setSnackbar", { text: "Error al eliminar registros.", color: "error" });
      });
    },
    importarPersonas() {
      if(!confirm("¿Está seguro? Este proceso importará a las personas activas y con cupo y se reemplazarán todos los datos de la planilla actual, ¿Desea continuar?")) return;
      let me = this;
      axios.post("api/planilla_detalles/ImportarPersonas/" + me.planillaActual.id, { usuario: me.usuario })
        .then(function (response) {
          me.listarDetalles(me.planillaActual.id);
          me.$store.dispatch("setSnackbar", { text: "Personas importadas exitosamente.", color: "success" });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: (error.response && error.response.data) || "Error", color: "error" });
        });
    },
    obtenerNombreCargo(id) {
      if (!Array.isArray(this.cargos)) return "";
      const cargo = this.cargos.find(c => c.id === id);
      return cargo ? cargo.descripcion : "";
    },
    obtenerNombreGrupo(id) {
      if (!Array.isArray(this.grupos)) return "";
      const g = this.grupos.find(x => x.id === id);
      return g ? g.descripcion : "";
    },
    formatoNumero(value, dec) {
      if (value == null) return "0.00";
      return parseFloat(value).toLocaleString("en-US", { minimumFractionDigits: dec, maximumFractionDigits: dec });
    },
    formatoFechaSpanish(fecha) {
      if (!fecha) return "";
      try {
        var m = new Date(fecha);
        var dateString =
          ("0" + m.getUTCDate()).slice(-2) + "-" + ("0" + (m.getUTCMonth() + 1)).slice(-2) + "-" + m.getUTCFullYear();
        return dateString;
      } catch (error) {
        return "";
      }
    }
  }
};
</script>
